import React from 'react';
import { Control, FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form/dist/types/form';
import {
    getMaxLength,
    getMaxLengthValidation,
    getMinLengthValidation,
    getPattern,
    handleAdditionalValidation,
    handleOnChange,
} from '@/components/dynamic-field/field-input/fieldInput.helper';
import { FieldProperties, FieldType, FieldValidation } from '@/services/formSchema.service';
import { FieldDescription } from '@/components/dynamic-field/field-description/FieldDescription';

export interface IDynamicInput {
    register: UseFormRegister<any>;
    validation: FieldValidation;
    setValue: UseFormSetValue<any>;
    watch: UseFormWatch<any>;
    errors?: FieldErrors<any>;
    fieldProperties: FieldProperties;
    formValues: FieldValues;
    control: Control;
    initialValue: string | boolean;
    fieldType: string;
    fieldName: string;
}

export const FieldInput: React.FC<IDynamicInput> = ({
    fieldType,
    register,
    validation,
    fieldName,
    initialValue,
    fieldProperties,
    setValue,
    watch,
}) => {
    const { maxLength, isRequired } = validation;
    const inputRegister = {
        ...register(fieldName, {
            onChange: handleOnChange(fieldName, fieldType, setValue, initialValue, fieldProperties),
            required: { value: isRequired.value, message: isRequired.message },
            ...getMaxLengthValidation(validation),
            ...getMinLengthValidation(validation),
            pattern: getPattern(validation),
            validate: handleAdditionalValidation(watch, validation),
        }),
    };
    const isTextArea = fieldType === FieldType.TEXTAREA;
    const isCheckbox = fieldType === FieldType.CHECKBOX;

    if (isTextArea) {
        return (
            <textarea
                {...inputRegister}
                data-testid={fieldName}
                defaultValue={initialValue as string}
                placeholder={fieldProperties.placeholder}
                maxLength={getMaxLength(maxLength?.value)}
                disabled={fieldProperties.disabled}
                id={fieldName}
                role="input"
            />
        );
    }

    return (
        <>
            <input
                {...inputRegister}
                type={fieldType}
                data-testid={fieldName}
                defaultValue={initialValue as string}
                placeholder={fieldProperties.placeholder}
                maxLength={getMaxLength(maxLength?.value)}
                disabled={fieldProperties.disabled}
                id={fieldName}
                role="input"
            />
            {!isCheckbox && <FieldDescription description={fieldProperties.description} />}
        </>
    );
};
